import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import "./ProductSectionTitle.scss";

const ProductSectionTitle = (props) => {
  const isArchive = props.isArchive,
    title = props.title.replace("&amp;", "&");
  return (
    <div className="ProductSectionTitle d-flex align-items-center justify-content-between">
      <h3 className="ProductSectionTitle__text">
        {!isArchive ? (
          <Link to={"/produktet/" + props.slug}>{title}</Link>
        ) : (
          <Fragment>{title}</Fragment>
        )}
      </h3>
      {!isArchive && (
        <Link
          to={"/produktet/" + props.slug}
          className="ProductSectionTitle__more"
        >
          Më Shumë
        </Link>
      )}
    </div>
  );
};

export default ProductSectionTitle;
